import { decodeJwt } from "jose"
import { useCallback, useEffect, useState } from "react"
import { fetchInterceptor } from "../http"

export type StepUpTokenService = {
  setStepUpToken: (token?: string) => void
  getStepUpToken: () => string | undefined
}

// localToken is needed for fetchInterceptor function reference
let localToken: string | undefined

export const useAppStepUpToken = (): { stepUpTokenService: StepUpTokenService } => {
  // useState is needed to have reactive interface
  const [token, setToken] = useState<string | undefined>(localToken)

  const setStepUpToken = useCallback((access_token?: string) => {
    if (access_token) {
      try {
        const jwt = decodeJwt(access_token)
        const now = Date.now()
        setToken(access_token)
        localToken = access_token

        // jwt.exp is in second but js work with millisecond
        const waitingTimeInMs = (jwt.exp ?? now / 1000) * 1000 - now
        setTimeout(
          () => {
            setToken(undefined)
            localToken = undefined
          },
          Math.max(waitingTimeInMs, 0),
        )
      } catch (error) {
        console.error("invalid JWT", error)
      }
    } else {
      setToken(undefined)
      localToken = undefined
    }
  }, [])

  const getStepUpToken = useCallback(() => token, [token])

  useEffect(() => {
    fetchInterceptor.add(async (options) => ({
      ...options,
      headers: {
        ...(options.headers || {}),
        "X-Step-Up-Authorization": localToken || "",
      },
    }))
  }, [])

  return {
    stepUpTokenService: {
      setStepUpToken,
      getStepUpToken,
    },
  }
}
